import { Autocomplete, Box, Divider, Grid, TextField, Tooltip, Typography } from "@mui/material";
import { SpeedOutlined } from "@mui/icons-material";

// Seção "Velocidade" (download/upload + seletor de Host CPE) do formulário de
// circuito. Puramente apresentacional (sem estado próprio) — extraído de
// circuito/index.js (etapa 19, passo 3, do plano de melhorias), mesmo
// JSX/comportamento, só movido de arquivo.
export default function VelocidadeSection({
  styles,
  formData,
  setFormData,
  editMode,
  loading,
  hostsCPE,
  handleNestedChange,
  temVelocidade,
}) {
  return (
    <>
      <Grid item xs={12} sx={styles.gritItemTitle}>
        <SpeedOutlined color="primary" />
        <Typography variant="mySubtitle2"> Velocidade</Typography>
      </Grid>
      <Grid container spacing={1} sx={styles.contentIdentation}>
        <Grid item xs={12} sm={6} lg={3}>
          <TextField
            sx={styles.textField}
            disabled={!editMode || loading}
            autoComplete="off"
            fullWidth
            label="Download"
            size="small"
            value={formData?.speed?.download}
            onChange={(e) =>
              handleNestedChange(
                "speed",
                "download",
                e.target.value
                  ?.replace(/[^0-9.]/g, "")
                  ?.replace(/(\..*)\./g, "$1")
                  ?.replace(/^(\d+(\.\d{0,2})?).*$/, "$1"),
              )
            }
            InputProps={{
              endAdornment: <Typography variant="body2">Mbps</Typography>,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <TextField
            sx={styles.textField}
            disabled={!editMode || loading}
            autoComplete="off"
            fullWidth
            size="small"
            label="Upload"
            value={formData?.speed?.upload}
            onChange={(e) =>
              handleNestedChange(
                "speed",
                "upload",
                e.target.value
                  ?.replace(/[^0-9.]/g, "")
                  ?.replace(/(\..*)\./g, "$1")
                  ?.replace(/^(\d+(\.\d{0,2})?).*$/, "$1"),
              )
            }
            InputProps={{
              endAdornment: <Typography variant="body2">Mbps</Typography>,
            }}
          />
        </Grid>
        {/* Seletor de Host CPE */}
        <Grid item xs={12} sm={6} lg={3}>
          <Tooltip
            title={
              !temVelocidade(formData?.speed?.download) ||
              !temVelocidade(formData?.speed?.upload)
                ? "É necessário preencher Download e Upload para selecionar o Host."
                : ""
            }
            arrow
            placement="top"
          >
            <Box>
              <Autocomplete
                sx={{
                  ...styles.textField,
                  "& .MuiOutlinedInput-root": {
                    padding: "4.5px 39px 4.5px 8px !important",
                  },
                }}
                disabled={
                  !editMode ||
                  loading ||
                  !temVelocidade(formData?.speed?.download) ||
                  !temVelocidade(formData?.speed?.upload)
                }
                size="small"
                options={hostsCPE}
                getOptionLabel={(o) => o?.host || ""}
                value={
                  hostsCPE?.find((h) => h?.hostid === formData?.hostId) || null
                }
                onChange={(_, v) => {
                  setFormData((prev) => ({
                    ...prev,
                    hostId: v?.hostid || "",
                    hostName: v?.host || "",
                  }));
                }}
                renderInput={(p) => (
                  <TextField size="small" {...p} label="Host" />
                )}
                noOptionsText="Nenhum host atrelado ao serviço, necessário configurar na sessão Configurações de Hosts"
              />
            </Box>
          </Tooltip>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </>
  );
}
